<ion-list>
  <ion-item *ngIf="authService.isLoggedIn" button="true" detail="true" (click)="onUserProfileBtnClicked()">
    <ion-icon class="ion-margin-end" name="person-outline" item-left></ion-icon>
    <ion-label>{{ userService.displayName }}</ion-label>
    <!-- <ion-label>teste</ion-label> -->

  </ion-item>

  <ion-item *ngIf="authService.isLoggedIn" button="true" detail="false" (click)="onUserProfileBtnClicked()">
    <ion-icon class="ion-margin-end" name="mail-outline" item-left></ion-icon>
    <ion-label>{{ userService.email$ | async }}</ion-label>
    <!-- <ion-label>teste</ion-label> -->

  </ion-item>

  <ion-item *ngIf="!authService.isLoggedIn" button="true" lines="none" detail="true" (click)="onSignInBtnClicked()">
    <ion-icon class="ion-margin-end" name="log-in-outline" item-left></ion-icon>
    <ion-label>Login</ion-label>
  </ion-item>

  <!-- <ion-item *ngIf="!authService.emailVerified() && authService.isLoggedIn" button="true" lines="none" detail="false" >
    <ion-icon class="ion-margin-end" name="mail-outline" item-left></ion-icon>
    <ion-label>Verify email</ion-label>
  </ion-item> -->

  <ion-item *ngIf="authService.isLoggedIn" lines="none" button="true" detail="false" (click)="onLogoutBtnClicked()">
    <ion-icon class="ion-margin-end" name="log-out-outline" item-left></ion-icon>
    <ion-label>Logout</ion-label>
  </ion-item>

  <ion-item *ngIf="authService.isLoggedIn && userService.isImpersonating$ | async" (click)="endImpersonation()">
    Sair do usuário
  </ion-item>
</ion-list>
